import { useEffect } from 'react';

import { router } from '../../../router/router';
import { isDynatraceEnabled } from '../constants';
import { dynatraceIntegration } from '../dynatraceIntegration';

const LAST_MATCH_INDEX = -1;

export const useDynatraceRouteTracking = () => {
	useEffect(() => {
		if (!isDynatraceEnabled) return;

		const unsubscribe = router.subscribe('onResolved', (routerState) => {
			const pathname = routerState.toLocation.pathname;
			const routePattern = router.state.matches.at(LAST_MATCH_INDEX)?.fullPath;
			dynatraceIntegration.reportPageChange(pathname, routePattern);
		});

		return unsubscribe;
	}, []);
};
